// tslint:disable-next-line:no-any
export let fvalue = (val: any) => (val && val.value !== undefined) ? val.value : val;


// WEBPACK FOOTER //
// ./src/form/util.ts